import { Injector } from '@angular/core';
import { functionCtaType } from '@app/finxone-web-frontend/app/lib/utils/cta-button-actions/cta-button-actions.utils';
import { ButtonActionType, UiZoneWidgetAttributeConfig } from '@finxone-platform/shared/sys-config-types';
import { initiateCloseSavingsAccount } from '../savings-account-actions/close-savings-account.utils';
import { initiateSavingsInternalTransfer } from '../savings-account-actions/internal-transfer.utils';
import { submitMaturityDecisionRenew } from '../savings-account-actions/maturity-decision-renew.utils';
import { submitMaturityDecisionWithdraw } from '../savings-account-actions/maturity-decision-withdraw.utils';
import { openNewSavingsAccount } from '../savings-account-actions/open-new-account.utils';
import { devTestClearPispInstitution } from '../savings-account-actions/dev-test-clear-pisp-institution.utils';
import { initiatePispDeposit, reviewPispDeposit } from '../savings-account-actions/pisp-deposit.utils';
import { processNominatedAccount } from '../savings-account-actions/process-nominated-account.utils';
import { reviewAccountRequests } from '../savings-account-actions/review-account-requests';
import {
  checkPayeeForNominatedAccount,
  updateNominatedAccount,
} from '../savings-account-actions/update-nominated-account.utils';
import { initiateWithdrawFromSavingsAccount } from '../savings-account-actions/withdraw-from-savings-account.utils';
import { submitMaturityDecisionPartialReinvest } from '../savings-account-actions/maturity-decision-partial-reinvest.utils';
import { cancelPendingWithdrawal } from '../payment-zone/cancel-pending-withdrawal.utils';
import { inviteJointAccountRequest } from '../savings-account-actions/invite-joint-account.utils';
import { acceptJointAccountRequest } from '../savings-account-actions/accept-joint-account-invitation.utils';
import { declineJointAccountRequest } from '../savings-account-actions/decline-joint-account-invitation.utils';
import { pispCancelRecurringPayment } from '../savings-account-actions/cancel-recurring-payment.utils';
export const savingsAccountActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.PROCESS_NOMINATED_ACCOUNT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      processNominatedAccount(injector);
    },
  ],
  [
    ButtonActionType.WITHDRAW_FROM_SAVINGS_ACCOUNT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      initiateWithdrawFromSavingsAccount(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.PISP_REVIEW,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      return reviewPispDeposit(injector, attri);
    },
  ],
  [
    ButtonActionType.PISP_DEPOSIT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      return initiatePispDeposit(injector, attri);
    },
  ],
  [
    ButtonActionType.DEV_TEST_CLEAR_PISP_INSTITUTION,
    (injector: Injector) => {
      devTestClearPispInstitution(injector);
    },
  ],
  [
    ButtonActionType.INITIATE_SAVINGS_INTERNAL_TRANSFER,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      initiateSavingsInternalTransfer(injector, attri);
    },
  ],
  [
    ButtonActionType.OPEN_NEW_SAVINGS_ACCOUNT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      openNewSavingsAccount(injector, attri);
    },
  ],
  [
    ButtonActionType.REVIEW_ACCOUNT_REQUESTS,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      reviewAccountRequests(injector, attri);
    },
  ],
  [
    ButtonActionType.MATURITY_DECISION_RENEW,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      submitMaturityDecisionRenew(injector, attri);
    },
  ],
  [
    ButtonActionType.CLOSE_SAVINGS_ACCOUNT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      initiateCloseSavingsAccount(injector, attri);
    },
  ],
  [
    ButtonActionType.MATURITY_DECISION_WITHDRAW,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      submitMaturityDecisionWithdraw(injector, attri);
    },
  ],
  [
    ButtonActionType.MATURITY_DECISION_PARTIAL_REINVEST,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      submitMaturityDecisionPartialReinvest(injector, attri);
    },
  ],
  [
    ButtonActionType.CANCEL_PENDING_WITHDRAWAL,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      cancelPendingWithdrawal(attri.widgetProperties, injector);
    },
  ],
  [
    ButtonActionType.CHECK_PAYEE_FOR_NOMINATED_BANK_ACCOUNT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      checkPayeeForNominatedAccount(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.UPDATE_NOMINATED_BANK_ACCOUNT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      updateNominatedAccount(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.INVITE_JOINT_ACCOUNT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      inviteJointAccountRequest(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.ACCEPT_JOINT_ACCOUNT_INVITATION,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      acceptJointAccountRequest(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.DECLINE_JOINT_ACCOUNT_INVITATION,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      declineJointAccountRequest(injector, attri.widgetProperties);
    },
  ],
  [
    ButtonActionType.PISP_CANCEL_RECURRING_PAYMENT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      pispCancelRecurringPayment(attri.widgetProperties, injector);
    },
  ],
]);
